import React from 'react';
import LegalPage from '@/components/LegalPage';
import usePageTitle from '@/hooks/usePageTitle';

const Disclaimer = () => {
  usePageTitle('Disclaimer');
  return (
  <LegalPage
    kicker="Legal"
    title="Disclaimer"
    lastUpdated="02 July 2026"
  >
    <p>
      The information, opinions, editorial content and creative work published
      on <strong>adauraawards.com</strong> are provided in good faith and for
      general informational and awards-recognition purposes only. Please read
      this disclaimer carefully before relying on anything you read here.
    </p>

    <h2>1. No professional advice</h2>
    <p>
      Nothing on the site constitutes marketing, legal, financial, taxation or
      investment advice. Frameworks, jury commentary, case studies and
      thought-leadership pieces are shared for reference; you should consult
      qualified professionals before applying any of it to your own business.
    </p>

    <h2>2. Entrant-submitted content</h2>
    <ul>
      <li>Campaign descriptions, results, screenshots, videos and any business claims (revenue lift, ROI, engagement, market share, etc.) published on the site are provided by the entrants themselves.</li>
      <li>Marketing Mind conducts reasonable diligence but does not independently audit or verify every claim. Marketing Mind is not responsible for factual inaccuracies or unverified performance metrics inside entrant-submitted material.</li>
      <li>Any dispute over the accuracy of an entrant’s claim should be raised with the entrant directly; where warranted, Marketing Mind will investigate under §7 of the <a href="/terms">Terms &amp; Conditions</a>.</li>
    </ul>

    <h2>3. Jury opinion</h2>
    <p>
      Jury scores, shortlists, awards and commentary reflect the independent
      professional judgment of the jurors at the time of scoring. They are
      opinions and should not be construed as verified endorsements of any
      product, service, brand, agency or professional.
    </p>

    <h2>4. External links</h2>
    <p>
      Where the site links to third-party websites, YouTube videos, LinkedIn
      profiles, agency portfolios or client case studies, we do so for
      convenience and context. We do not endorse and are not responsible for
      the content, availability or practices of any linked third-party site.
    </p>

    <h2>5. Availability</h2>
    <p>
      We take reasonable steps to keep the site available around the clock, but
      we do not warrant uninterrupted or error-free operation. Scheduled
      maintenance, third-party outages (Razorpay, Cloudflare, Google, MongoDB
      Atlas) or force-majeure events may cause temporary unavailability.
      Deadline-adjacent outages are handled per §7 of the{' '}
      <a href="/terms">Terms &amp; Conditions</a>.
    </p>

    <h2>6. Limitation of liability</h2>
    <p>
      To the maximum extent permitted by Indian law, Marketing Mind and Digi
      Giant LLP disclaim all warranties, express or implied. Our aggregate
      liability arising out of the Awards is limited to the entry fee actually
      paid, as detailed in §9 of the <a href="/terms">Terms &amp; Conditions</a>.
    </p>

    <h2>7. Trademarks</h2>
    <p>
      All third-party brand names, product names, logos and trademarks
      appearing on the site remain the property of their respective owners.
      Their use on adauraawards.com is nominative and does not imply any
      endorsement, sponsorship or affiliation unless expressly stated.
    </p>

    <h2>8. Fraud &amp; impersonation</h2>
    <p>
      Marketing Mind never contacts entrants or jurors asking for OTPs,
      passwords, or payment outside the official Razorpay checkout on
      adauraawards.com. Any communication requesting a UPI transfer, wire, or
      instant-messaging payment claiming to be from “AdAura Awards” is
      fraudulent — please report it to{' '}
      <a href="mailto:awards@marketingmind.co">awards@marketingmind.co</a>.
    </p>
  </LegalPage>
  );
};

export default Disclaimer;
